export default function tiles() {

    function closestEdge(x, y, w, h) {
        var topEdgeDist = distMetric(x, y, w / 2, 0),
            bottomEdgeDist = distMetric(x, y, w / 2, h),
            leftEdgeDist = distMetric(x, y, 0, h / 2),
            rightEdgeDist = distMetric(x, y, w, h / 2);

        var min = Math.min(topEdgeDist, bottomEdgeDist, leftEdgeDist, rightEdgeDist);
        switch (min) {
            case leftEdgeDist:
                return "left";
            case rightEdgeDist:
                return "right";
            case topEdgeDist:
                return "top";
            case bottomEdgeDist:
                return "bottom";
        }
    }

    function distMetric(x, y, x2, y2) {
        var xDiff = x - x2,
            yDiff = y - y2;
        return (xDiff * xDiff) + (yDiff * yDiff);
    }

    $('.articles__item').hover(function (e) {
        var el_pos = $(this).offset(),
        edge = closestEdge(e.pageX - el_pos.left, e.pageY - el_pos.top, $(this).width(), $(this).height());
        $(this).removeClass('out-left out-right out-top out-bottom');
        $(this).addClass('in-' + edge);
    }, function (e) {
        var el_pos = $(this).offset(),
            edge = closestEdge(e.pageX - el_pos.left, e.pageY - el_pos.top, $(this).width(), $(this).height());
        $(this).removeClass('in-left in-right in-top in-bottom');
        $(this).addClass('out-' + edge);
    });

}